__turbopack_context__.v({
  "className": "anton_54ebe129-module__JtiY7W__className",
});
